import styled from 'styled-components';
import { GalleryImageProps, GalleryStyledProps } from './Gallery.typed';

export const Gallery = styled.div<GalleryStyledProps>`
  position: relative;
  max-height: 100%;
  height: ${({ height }) => height ?? '100%'};
  overflow: hidden;
`;

export const GalleryImage = styled.div<GalleryImageProps>`
  text-align: center;
`;

export const Item = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-align: center;
`;

export const Controls = styled.div`
  button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    color: #fff;
    background-color: #000a;
    border-radius: 50%;

    &:first-child {
      left: 1rem;

      svg {
        transform: rotate(90deg);
      }
    }
    &:last-child {
      right: 1rem;

      svg {
        transform: rotate(-90deg);
      }
    }
  }
`;
